
import styles from "./AlertCommon.module.scss";

export const AlertCommon = () => {
  return (
    <div id="alert" className={styles.container} />
  );
};
